import React, { useEffect, useState } from "react";
import App from "./App";
import LoadingScreen from "./components/LoadingScreen";
import BASE_CONFIG from "./config";
const GA_KEY = BASE_CONFIG.GA_KEY
function Store() {
  const [room, setRoom] = useState(null);
  const [user, setUser] = useState(null);
  const [URLData, setURLData] = useState(null);
  const [stateHydrated, setStateHydrated] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.innerHTML = ((function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', GA_KEY))
  }, [stateHydrated])
  //Hydrate state from localStorage
  useEffect(() => {
    if (!stateHydrated) {
      let data = { href: window.location.href, params: {} };
      const queryParams = new URLSearchParams(window.location.search);
      for (const [key, value] of queryParams.entries()) {
        data.params[key] = value;
      }
      setURLData(data);

      let user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.id) {
        user = null;
      }
      setUser(user);

      let room = JSON.parse(localStorage.getItem("room"));
      // if (!room) {
      //   //room = {'messages':{}}
      //   room = null;
      // } else {
      //   room.messages = {}
      // }
      setRoom(room);

      console.log("state hydrated");
      setStateHydrated(true);
    }
  }, [stateHydrated]);

  useEffect(() => {
    // Don't persist room joined state
    localStorage.setItem(
      "room",
      JSON.stringify({ ...room, ...{ joined: false } })
    );
  }, [room]);

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(user));
  }, [user]);

  return stateHydrated ? (
    <App
      URLData={URLData}
      setRoom={setRoom}
      setUser={setUser}
      user={user}
      room={room}
    />
  ) : (
    <LoadingScreen></LoadingScreen>
  );
}

export default Store;
